import React from 'react'
import loadable from '@loadable/component'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from 'react-router-dom'

const ScrollToTop = loadable(() => import('./scrollToTop'))
const PriceEstimator = loadable(() => import('./containers/priceEstimator/index'))
const PlaceOrder = loadable(() => import('./containers/placeOrderNew/index'))
const OrderResponse = loadable(() => import('./containers/placeOrderNew/orderResponse'))
const Login = loadable(() => import('./containers/authPages/login'))
const Signup = loadable(() => import('./containers/authPages/signup'))
const Profile = loadable(() => import('./containers/customer/profile'))
const PaymentMethod = loadable(() => import('./containers/customer/paymentMethod'))
const Cleaning = loadable(() => import('./containers/customer/cleaning'))
const Delivery = loadable(() => import('./containers/customer/delivery'))
const OrderHistory = loadable(() => import('./containers/customer/orderHistory'))
const ActiveOrder = loadable(() => import('./containers/customer/activeOrders'))
const StopWashRepeat = loadable(() => import('./containers/customer/stopWashRepeat'))
const Subscription = loadable(() => import('./containers/subscription'))
const StopWashGo = loadable(() => import('./containers/customer/stopWashGo'))
const ForgotPassword = loadable(() => import('./containers/authPages/forgotPassword'))

const InnerLayout = loadable(() => import('./layouts/inc/innerLayout'))
const OrderLayout = loadable(() => import('./layouts/inc/orderLayout'))
const SubscriptionPack = loadable(() => import('./layouts/inc/subscriptionLayout'))
const AuthRoute = loadable(() => import('./layouts/inc/authLayout'))
const ProtectedRoute = loadable(() => import('./layouts/inc/protectedLayout'))
const LandingPageLayout = loadable(() => import('./layouts/inc/landingPageLayout'))

class Routes extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Router>
                    <ScrollToTop/>
                    <Switch>
                        <Redirect strict from={"/home/"} to={"/"}/>

                        <InnerLayout exact path="/">
                            <Redirect to="/place-order" exact/>
                        </InnerLayout>

                        <InnerLayout exact path="/home">
                            <Redirect to="/place-order" exact/>
                        </InnerLayout>

                        <LandingPageLayout path="/price-estimator" component={PriceEstimator} exact/>
                        <OrderLayout path="/place-order" component={PlaceOrder} exact/>
                        <InnerLayout path="/order-success" component={OrderResponse} exact/>

                        <SubscriptionPack path="/start/plan" component={Subscription} exact/>

                        <AuthRoute path="/login" component={Login} exact/>
                        <AuthRoute path="/forgot-password" component={ForgotPassword} exact/>
                        <AuthRoute path="/customer/start" component={Signup} exact/>


                        <ProtectedRoute path="/profile" component={Profile} exact/>
                        <ProtectedRoute path="/payment-method" component={PaymentMethod} exact/>
                        <ProtectedRoute path="/active-order" component={ActiveOrder} exact/>
                        <ProtectedRoute path="/order-history" component={OrderHistory} exact/>
                        <ProtectedRoute path="/preferences-delivery" component={Delivery} exact/>
                        <ProtectedRoute path="/preferences-cleaning" component={Cleaning} exact/>
                        <ProtectedRoute path="/subscription-repeat" component={StopWashRepeat} exact/>
                        <ProtectedRoute path="/subscription-go" component={StopWashGo} exact/>

                        <Route path="*" exact>
                            <Redirect to="/"/>
                        </Route>

                    </Switch>
                </Router>
            </React.Fragment>
        )
    }
}

export default Routes
